module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-home"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props && !_vm.loading) ? _c('div', {
    staticClass: "homepage"
  }, [_c('Header'), _c('div', {
    staticClass: "banner_block"
  }, [_c('video', {
    staticClass: "video",
    attrs: {
      "autoplay": "",
      "loop": "",
      "muted": ""
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.props.acf.home_background_video,
      "type": "video/mp4"
    }
  })]), _c('div', {
    staticClass: "innerhm"
  }, [_c('div', {
    staticClass: "innerhm1"
  }, [_c('div', {
    staticClass: "innerhm2"
  }, [_c('div', {
    staticClass: "sec_1_content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.homepage_section1_title)
    }
  }), _c('div', {
    staticClass: "subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.homepage_section1_subtitle)
    }
  })])])])]), _c('div', {
    staticClass: "HomeAbout"
  }, [_c('div', {
    staticClass: "HomeAbout__Container"
  }, [_c('div', {
    staticClass: "HomeAbout__Box"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.abtinfocontent)
    }
  })]), _c('div', {
    staticClass: "HomeAbout__Gbwbtn"
  }, [_c('a', {
    attrs: {
      "href": _vm.props.acf.abtinfourl,
      "target": "_blank"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.abtinfobtn)
    }
  })])])]), _c('div', {
    staticClass: "review-home"
  }, [(_vm.props.acf.our_reviews_title) ? _c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.our_reviews_title)
    }
  }) : _vm._e(), _c('hr', {
    staticClass: "all_hr"
  }), _c('div', {
    staticClass: "reviews-section"
  }, [(_vm.propsreview.acf.testimonial_list) ? _c('div', {
    staticClass: "testimonial-slider"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOption1
    }
  }, [_vm._l((_vm.propsreview.acf.testimonial_list), function(testimonialList, index) {
    return _c('swiper-slide', [_c('div', {
      staticClass: "testimonial-slide_inner"
    }, [(_vm.propsreview.acf.testimonial_star) ? _c('img', {
      staticClass: "testimonial-star",
      attrs: {
        "src": _vm.propsreview.acf.testimonial_star
      }
    }) : _vm._e(), (testimonialList.description) ? _c('p', {
      staticClass: "testimonial-slide_content",
      domProps: {
        "innerHTML": _vm._s(testimonialList.description)
      }
    }) : _vm._e(), (testimonialList.author) ? _c('p', {
      staticClass: "testimonial-author",
      domProps: {
        "innerHTML": _vm._s(testimonialList.author)
      }
    }) : _vm._e()])])
  }), _c('div', {
    staticClass: "swiper-button-prev",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  }), _c('div', {
    staticClass: "swiper-button-next",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  })], 2)], 1) : _vm._e()])]), _c('div', {
    staticClass: "specials"
  }, [_c('div', {
    staticClass: "schedule_appoint_section"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.section_4_content.title)
    }
  }), _c('hr', {
    staticClass: "all_hr"
  }), _c('div', {
    staticClass: "email-container"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "company-info"
  }, [_c('ul', [_c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.section_4_content.address)
    }
  }), _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.section_4_content.phone)
    }
  }), _c('br'), _c('br'), _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.section_4_content.hours)
    }
  })])]), _c('div', {
    staticClass: "contact"
  }, [_c('h3', [_vm._v("Email Us")]), _c('div', {
    staticClass: "appoint-wrap contact-form"
  }, [_c('CustomForm')], 1)])])])])]), _c('Footer')], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c19f83e0","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/home/home.pug
// module id = 554
// module chunks = 1